import { IS_PRODUCTION, SITE_URL } from "@constants";

export const getAbsoluteUrl = (path: string, locale?: string) => {
  path = `${locale === "ja" ? "/ja" : ""}${path}`;

  if (IS_PRODUCTION) {
    return `${SITE_URL}${path}`;
  }

  return path;
};
